/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface EntertainmentCreditState {
  loading: boolean;
  submitSuccess: any | null;
  submitError: any | null;
}

const initialState: EntertainmentCreditState = {
  loading: false,
  submitSuccess: null,
  submitError: null,
};

const entertainmentCreditSlice = createSlice({
  name: 'entertainmentCredit',
  initialState,
  reducers: {
    entertainmentCreditRequest(
      state,
      _action: PayloadAction<{ accountId: string; data: any }>
    ) {
      state.loading = true;
      state.submitSuccess = null;
      state.submitError = null;
    },
    entertainmentCreditSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.submitSuccess = action.payload; // full success payload (message, statuscode, etc.)
      state.submitError = null;
    },
    entertainmentCreditFailed(state, action: PayloadAction<any>) {
      state.loading = false;
      state.submitSuccess = null;
      state.submitError = action.payload; // normalized error payload
    },
    resetEntertainmentCreditState() {
      return initialState;
    },
  },
});

export const {
  entertainmentCreditRequest,
  entertainmentCreditSuccess,
  entertainmentCreditFailed,
  resetEntertainmentCreditState,
} = entertainmentCreditSlice.actions;

export default entertainmentCreditSlice.reducer;

